import { List } from "immutable";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";

import { withContainerContext } from "../../components/container/ContainerContext";
import SplitView from "../../components/splitView";
import { RELATIONSHIP_ENTITY_COLUMN_WIDTH, RELATIONSHIP_EVENT_COLUMN_WIDTH } from "../../constants";
import { scalePixelsToFontSize } from "../../constants/styles/dimensions";
import { immutableRecords, PropTypeShapes } from "../../types";
import RelationshipScrollBackgroundCanvasView from "./RelationshipScrollBackgroundCanvasView";
import selectors from "./selectors";

class RelationshipScrollBackgroundView extends PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  renderSplitView() {
    const SCALED_EVENT_COLUMN_WIDTH = scalePixelsToFontSize(RELATIONSHIP_EVENT_COLUMN_WIDTH, this.props.fontSize);
    const SCALED_ENTITY_COLUMN_WIDTH = scalePixelsToFontSize(RELATIONSHIP_ENTITY_COLUMN_WIDTH, this.props.fontSize);

    let splitProps;
    splitProps = {
      vertical: true,
      hasShadow: false,
      constraints: List([
        immutableRecords.SplitConstraintsRecord({
          minSize: SCALED_EVENT_COLUMN_WIDTH,
          maxSize: SCALED_EVENT_COLUMN_WIDTH,
          preferredSize: SCALED_EVENT_COLUMN_WIDTH
        }),
        immutableRecords.SplitConstraintsRecord({
          minSize: SCALED_ENTITY_COLUMN_WIDTH,
          canResize: false,
          preferredSize: 1000
        })
      ])
    };

    const blackoutStyle = {
      left: "0px",
      top: "0px",
      width: `${SCALED_EVENT_COLUMN_WIDTH}px`,
      height: `${this.props.containerRect.height}px`
    };

    const childComponents = [
      <div key="backgroundBlockout" className="relationshipBackgroundBlockout" style={blackoutStyle} />,
      <RelationshipScrollBackgroundCanvasView key="backgroundCanvas" {...this.props} />
    ];

    return (
      <SplitView key="relationshipScrollBackgroundSplitView" {...splitProps}>
        {childComponents}
      </SplitView>
    );
  }

  render() {
    return this.props.hasData ? (
      <div className="relationshipScrollBackgroundView">{this.renderSplitView()}</div>
    ) : (
      <div />
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    hasData: selectors.doesRelationshipViewHaveData(state.present, props.viewIds.first())
  };
};
const mapDispatchToProps = _dispatch => {
  return {};
};

RelationshipScrollBackgroundView.propTypes = {
  fontSize: PropTypes.number.isRequired,
  colGroups: PropTypeShapes.relationshipColumnGroupList.isRequired,
  viewIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  hasData: PropTypes.bool.isRequired,

  // From containerContext
  containerRect: PropTypeShapes.flatRect.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(withContainerContext(RelationshipScrollBackgroundView));
